import { MEMBER_CLASSES_ACTION_TYPES } from "./memberClasses.types";
import { createAction } from "../../utils/reducer/reducer.utils"

export const setMemberClasses = (classes: any) => createAction(MEMBER_CLASSES_ACTION_TYPES.SET_CLASSES, classes);